import * as httpErrorsTypes from '../../consts/app/httpErrorsTypes';
import * as gigyaService from '../gigya/gigyaService';
import HttpErrorHandlerService from '../httpErrorHandlerService';

const muleSoftResponseErrorCheckService = async (error, isHandleError = true) => {
    const isAuthError = error?.response?.status === httpErrorsTypes.NOT_AUTHORIZED;

    if (isAuthError) {
        return await gigyaService.refreshGigyaToken();
    } else {
        if (isHandleError) {
            new HttpErrorHandlerService().handleError(error);
        }
        throw error;
    }
};

export default muleSoftResponseErrorCheckService;
